import { Injectable } from '@angular/core';
import { StorageService } from '../../data/browser/storage.service';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { ITransactions } from '../models/app.model';

@Injectable({
  providedIn: 'root',
})
export class HandleTokenService {
  constructor(private _storageService: StorageService) {}

  public setAccessToken(token: string): void {
    this._storageService.setItem(CONST.PROP_SESSION_TOKEN, token);
  }

  public getAccessToken(): string | object | null {
    return this._storageService.getItem(CONST.PROP_SESSION_TOKEN);
  }

  public removeAccessToken(): void {
    return this._storageService.removeItem(CONST.PROP_SESSION_TOKEN);
  }

  public setTransactionId(transactionId: string): void {
    return this._storageService.setItem(CONST.PROP_TRANSACTION_ID, transactionId);
  }

  public removeTransactionMinMax(): void {
    this._storageService.removeItem(CONST.PROP_TRANSACTION_MIN);
    this._storageService.removeItem(CONST.PROP_TRANSACTION_AMOUNT);
    return this._storageService.removeItem(CONST.PROP_TRANSACTION_MAX);
  }

  public getTransactionId(): string {
    const transactionId: string | object | null = this._storageService.getItem(
      CONST.PROP_TRANSACTION_ID
    );
    return typeof transactionId === 'string' ? transactionId : transactionId?.toString();
  }

  public cancelTransactionId(): void {
    return this._storageService.removeItem(CONST.PROP_TRANSACTION_ID);
  }

  public setUserStep(step: number): void {
    this._storageService.setItem(CONST.PROP_USER_STEP, step.toString());
  }

  public getUserStep(): string | object {
    return this._storageService.getItem(CONST.PROP_USER_STEP);
  }

  public removeUserStep(): void {
    return this._storageService.removeItem(CONST.PROP_USER_STEP);
  }

  public setTransactionToken(token: string): void {
    return this._storageService.setItem(CONST.PROP_TRANSACTION_TOKEN, token);
  }

  public getTransactionToken(): string {
    const transactionToken: string | object | null = this._storageService.getItem(
      CONST.PROP_TRANSACTION_TOKEN
    );
    return typeof transactionToken === 'string' ? transactionToken : transactionToken?.toString();
  }

  public removeTransactionToken(): void {
    return this._storageService.removeItem(CONST.PROP_TRANSACTION_TOKEN);
  }

  public removeAuthCustomer() {
    const key: string = CONST.PROP_CUSTOMER;
    return this._storageService.removeItem(key);
  }

  public cleanAndRemoveAllData(): void {
    this.removeAccessToken();
    this.removeUserStep();
    this.removeAuthCustomer();
  }
}
